<template>
  <v-app>
    <v-main class="main-bg">

      <!-- HERO / BANNER -->
      <Header :event-details="event" />
      <v-container class="mt-2">
        <v-row class="d-flex align-center justify-center">
          <v-col cols="12" sm="12" md="12" lg="4" class="text-center">
            <h1>Become an Exhibitor</h1>
          </v-col>
          <v-col cols="12" sm="12" md="12" lg="8">
            <div class="stepper-wrapper">
              <div class="step">
                <div class="circle">
                  <v-icon color="white">mdi-domain</v-icon>
                </div>
                <span>Company Info</span>
              </div>

              <div class="line"></div>

              <div class="step">
                <div class="circle">
                  <v-icon color="white">mdi-store-outline</v-icon>
                </div>
                <span>Business Details</span>
              </div>

              <div class="line"></div>

              <div class="step">
                <div class="circle">
                  <v-icon color="white">mdi-shield-check-outline</v-icon>
                </div>
                <span>Preferences &amp; Consent</span>
              </div>

            </div>
          </v-col>
        </v-row>
      </v-container>

      <!-- STEP FORM -->
      <section class="form-section" ref="registrationSection">
        <v-container>
          <v-row class="mt-10 pb-1" align="stretch">
            <!-- LEFT: COMPANY INFO -->
            <v-col cols="12" md="6">
              <v-card class="pa-5 form-card fill-height" rounded="xl" elevation="2">
                <v-card-text>
                  <div class="section-title mb-6">
                    <v-icon color="brown darken-2">mdi-domain</v-icon>
                    Company Information
                  </div>

                  <v-text-field outlined dense label="Business Name *" color="brown"
                    v-model="details.business_name"></v-text-field>
                  <v-text-field outlined dense label="Business Address *" color="brown"
                    v-model="details.business_address"></v-text-field>
                  <v-row no-gutters>
                    <v-col cols="12" md="6" class="pr-md-2">
                      <v-text-field outlined dense label="Contact Person *" color="brown"
                        v-model="details.contact_person"></v-text-field>
                    </v-col>
                    <v-col cols="12" md="6" class="pl-md-2">
                      <v-text-field outlined dense label="Position *" color="brown"
                        v-model="details.position"></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row no-gutters>
                    <v-col cols="12" md="6" class="pr-md-2">
                      <v-text-field outlined dense label="Mobile Number *" color="brown"
                        v-model="details.mobile_number"></v-text-field>
                    </v-col>
                    <v-col cols="12" md="6" class="pl-md-2">
                      <v-text-field outlined dense label="Viber Number" color="brown"
                        v-model="details.viber_number"></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row no-gutters>
                    <v-col cols="12" md="6" class="pr-md-2">
                      <v-text-field outlined dense label="Landline Number" color="brown"
                        v-model="details.landline_number"></v-text-field>
                    </v-col>
                    <v-col cols="12" md="6" class="pl-md-2">
                      <v-text-field outlined dense label="Email Address *" color="brown"
                        v-model="details.email_address"></v-text-field>
                    </v-col>
                  </v-row>
                  <v-text-field outlined dense label="Website" color="brown" v-model="details.website"></v-text-field>
                  <v-row no-gutters>
                    <v-col cols="12" md="6" class="pr-md-2">
                      <v-text-field outlined dense label="Facebook Page" color="brown"
                        v-model="details.facebook_page"></v-text-field>
                    </v-col>
                    <v-col cols="12" md="6" class="pl-md-2">
                      <v-text-field outlined dense label="Instagram" color="brown"
                        v-model="details.instagram"></v-text-field>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>

            <!-- RIGHT: REGISTRATION + CATEGORY -->
            <v-col cols="12" md="6">
              <v-card class="pa-5 form-card fill-height" rounded="xl" elevation="2">
                <v-card-text>
                  <div class="section-title mb-6">
                    <v-icon color="brown darken-2">mdi-certificate-outline</v-icon>
                    Business Registration
                  </div>

                  <div class="dynamic-title mb-4">
                    Please select the option that best describes your registration status.
                  </div>
                  <div class="text-sm mb-2" style="color:#8d6e63;">
                    (Optional for verification only)
                  </div>
                  <v-radio-group v-model="details.registration_type">
                    <div class="mb-2">
                      <v-radio 
                        label="Philippine-Based Exhibitor with Business TIN" 
                        value="Philippine-Based Exhibitor with Business TIN" 
                        color="brown darken-2"></v-radio>
                    </div>
                    <div class="mb-2">
                      <v-radio 
                        label="Philippine Individual with Personal TIN" 
                        value="Philippine Individual with Personal TIN" 
                        color="brown darken-2"></v-radio>
                    </div>
                    <div class="mb-2">
                      <v-radio 
                        label="Philippine-Based Exhibitor without TIN" 
                        value="Philippine-Based Exhibitor without TIN" 
                        color="brown darken-2"></v-radio>
                    </div>
                    <div>
                      <v-radio 
                        label="International Exhibitor (No Philippine TIN Required)" 
                        value="International Exhibitor (No Philippine TIN Required)" 
                        color="brown darken-2"></v-radio>
                    </div>
                  </v-radio-group>

                  <div class="mt-5">
                    <div class="dynamic-title mb-4">
                      Event Categories
                    </div>
                    <v-row no-gutters>
                      <v-col cols="12" sm="6" v-for="option in eventCategoryOptions" :key="option.id" >
                        <v-card outlined class="pa-4 cursor-pointer mb-2 mr-2" @click="toggleEventCategory(option)">
                          <div class="d-flex justify-space-between align-center">
                            <div>
                              <div class="text-subtitle-1 font-weight-bold">
                                {{ option.label }}
                              </div>
                            </div>
                            <v-icon :color="isEventCategorySelected(option.id) ? 'gold' : ''">
                              {{ isEventCategorySelected(option.id) ? 'mdi-check-circle' : 'mdi-checkbox-blank-circle-outline' }}
                            </v-icon>
                          </div>
                        </v-card>
                      </v-col>
                    </v-row>
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>

          <v-row class="mt-5 pb-1" align="stretch">
            <!-- LEFT: BUSINESS DETAILS -->
            <v-col cols="12" md="6">
              <v-card class="pa-5 form-card fill-height" rounded="xl" elevation="2">
                <v-card-text>
                  <div class="section-title mb-6">
                    <v-icon color="brown darken-2">mdi-store-outline</v-icon>
                    Tell Us About Your Business
                  </div>

                  <v-textarea outlined dense label="Business" color="brown" rows="2"
                    v-model="details.about_business"></v-textarea>
                  <v-textarea outlined dense label="Product" color="brown" rows="2"
                    v-model="details.about_product"></v-textarea>
                  <v-textarea outlined dense label="Services" color="brown" rows="2"
                    v-model="details.about_services"></v-textarea>

                  <div class="mt-5">
                    <div class="dynamic-title mb-4">
                      Preferred Event
                    </div>
                    <v-row>
                      <v-col cols="12" sm="6" 
                        v-for="option in activeEvents" 
                        :key="option.id">
                        <v-card outlined class="pa-4 cursor-pointer"
                          @click="toggleEvent(option)">
                          <div class="d-flex justify-space-between align-center">
                            <div>
                              <div class="text-subtitle-1 font-weight-bold">
                                {{ option.name }}
                              </div>

                              <div class="text-caption grey--text">
                                {{ option.display_date }} | {{ option.location }}
                              </div>

                              <div class="mt-2">
                                {{ option.description }}
                              </div>
                            </div>
                            <v-icon :color="isEventSelected(option.id) ? 'gold' : ''">
                              {{ isEventSelected(option.id) ? 'mdi-check-circle' : 'mdi-checkbox-blank-circle-outline' }}
                            </v-icon>
                          </div>
                        </v-card>
                      </v-col>
                    </v-row>
                  </div>
                </v-card-text>
              </v-card>
            </v-col>

            <!-- RIGHT: EVENTS TO JOIN + CONSENT -->
            <v-col cols="12" md="6">
              <v-card class="pa-5 form-card" rounded="xl" elevation="2">
                <v-card-text>
                  <div class="section-title mb-6">
                    <v-icon color="brown darken-2">mdi-calendar-multiple</v-icon>
                    Preferred size of exhibit area, other inquiries:
                  </div>
                  <v-textarea outlined dense label="Enter details" color="brown" rows="5" v-model="details.other_inquiries"></v-textarea>
                </v-card-text>
              </v-card>

              <v-card rounded="xl" class="mt-5 pa-5">
                <v-card-text>
                  <div class="section-title mb-6">
                    <v-icon color="brown darken-2">mdi-shield-outline</v-icon>
                    Consent
                  </div>
                  <div>
                    <label class="text-md">
                      I have read and agree to the Magnus Eventus Inc. Privacy Policy and Data Collection
                      Terms. I consent to be contacted regarding exhibitor opportunities, sponsorship
                      packages, event participation, and related promotional communications.
                    </label>
                    <v-checkbox v-model="details.consent" label="Yes, I agree" color="brown darken-2" hide-details
                      dense />
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>

          <!-- SUBMIT -->
          <div class="text-center mt-10">
            <v-btn x-large rounded color="brown darken-3" class="white--text px-12" @click="submit()" :loading="loading">
              Submit Registration
            </v-btn>
          </div>

        </v-container>
      </section>
      <Footer />
    </v-main>

    <v-dialog v-model="errorsDialog" max-width="500">
      <v-card>
        <v-card-title class="text-h5">Please fix the following errors:</v-card-title>
        <v-list dense>
          <v-list-item v-for="(item, i) in errors" :key="i">
            <v-list-item-content>
              {{ item[0] }}
            </v-list-item-content>
          </v-list-item>
        </v-list>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="errorsDialog = false">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="successDialog" max-width="300">
      <v-card>
        <v-card-text class="text-center pa-4">
          <h3>Registration Successful!</h3>
        </v-card-text>
        <v-card-text class="text-center">
          <v-icon color="green" class="text-xxl mb-2">mdi-check-circle</v-icon>
          <p>Thank you for registering as an exhibitor. Our team will reach out shortly.</p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="success" @click="successDialog = false" outlined block>OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import api from '@/services/axios';
import Header from '../components/Header.vue';
import Footer from '../components/Footer.vue';

export default {
  name: 'ExhibitorRegistration',
  components: { Header, Footer },
  data() {
    return {
      loading: false,
      event: {},
      activeEvents: [],
      errorsDialog: false,
      successDialog: false,
      errors: [],

      eventCategoryOptions: [
        { label: 'Wedding', id: 'Wedding' },
        { label: 'Travel', id: 'Travel' },
        { label: 'Celebrations', id: 'Celebrations' },
      ],

      // Replace with your actual event titles
      preferredEventOptions: [],

      details: {
        business_name: '',
        business_address: '',
        contact_person: '',
        position: '',
        mobile_number: '',
        viber_number: '',
        landline_number: '',
        email_address: '',
        website: '',
        facebook_page: '',
        instagram: '',
        has_ph_registration: null,
        event_categories: [],
        about_business: '',
        about_product: '',
        about_services: '',
        preferred_events: [],
        events_to_join: [
          { year: '', location: '' }
        ],
      },
    };
  },
  async mounted() {
    try {
      let response = await api.get(process.env.VUE_APP_API_URL + '/active-events');

      this.activeEvents = response.data;

    } catch (error) {
      console.log(error);
    }
  },
  methods: {
    addEventEntry() {
      this.details.events_to_join.push({ year: '', location: '' });
    },
    removeEventEntry(index) {
      if (this.details.events_to_join.length > 1) {
        this.details.events_to_join.splice(index, 1);
      }
    },
    toggleEvent(event) {
      if(this.details.preferred_events.find(e => e.id == event.id)) {
        this.details.preferred_events = this.details.preferred_events.filter(e => e.id != event.id);
      }
      else {
        this.details.preferred_events.push(event);
      }
    },
    isEventSelected(id) {
      return this.details.preferred_events.some(e => e.id == id);
    },
    toggleEventCategory(category) {
      if(this.details.event_categories.some(c => c.id == category.id)) {
        this.details.event_categories = this.details.event_categories.filter(c => c.id != category.id);
      }
      else {
        this.details.event_categories.push(category);
      }

      console.log(this.details.event_categories);
    },
    isEventCategorySelected(id) {
      return this.details.event_categories.some(c => c.id == id);
    },
    goToRegistrationPage() {
      this.$refs.registrationSection.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    },
    submit() {
      this.loading = true;
      api.post('/exhibitor-registration', this.details)
        .then(() => {
          this.successDialog = true;
          this.details = {
            business_name: '',
            business_address: '',
            contact_person: '',
            position: '',
            mobile_number: '',
            viber_number: '',
            landline_number: '',
            email_address: '',
            website: '',
            facebook_page: '',
            instagram: '',
            has_ph_registration: null,
            event_categories: [],
            about_business: '',
            about_product: '',
            about_services: '',
            preferred_events: [],
            events_to_join: [
              { year: '', location: '' }
            ],
            consent: false,
          };

          fbq('track', 'Lead', {
            content_name: 'PTIDO Exhibitor Registration',
            content_category: 'Exhibitor Registration',
            registration_type: 'exhibitor'
          });
        })
        .catch(error => {
          console.error('Error submitting registration:', error);
          this.errors = error.response.data.errors;
          this.errorsDialog = true;
        }).finally(() => {
          this.loading = false;
        });
    }
  },
};
</script>

<style scoped>
.main-bg {
  background: #f8f5f1;
}

/* FORM */
.form-section {
  margin-top: -40px;
  position: relative;
  z-index: 5;
  padding-bottom: 80px;
}

.form-card {
  border-radius: 24px;
  background: white;
}

.section-title {
  display: flex;
  align-items: center;
  gap: 10px;

  font-size: 22px;
  font-weight: 700;
  color: #4e342e;
}

.dynamic-title {
  font-size: 18px;
  font-weight: 700;
  color: #5d4037;
}

/* STEPPER */
.stepper-wrapper {
  padding: 24px 30px;
  border-radius: 24px;

  display: flex;
  align-items: center;
  justify-content: center;

  flex-wrap: wrap;
}

.step {
  display: flex;
  flex-direction: column;
  align-items: center;

  min-width: 100px;
}

.circle {
  width: 42px;
  height: 42px;
  border-radius: 50%;

  background: #d7ccc8;
  color: #5d4037;

  display: flex;
  align-items: center;
  justify-content: center;

  font-weight: bold;
  margin-bottom: 8px;
}

.step.active .circle {
  background: #5d4037;
  color: white;
}

.step span {
  font-size: 13px;
  color: #6d4c41;
  font-weight: 600;
}

.line {
  width: 70px;
  height: 2px;
  background: #d7ccc8;
  margin: 0 10px;
}

.text-md {
  font-size: 16px;
}

.text-sm {
  font-size: 14px;
}

.text-xxl {
  font-size: 5rem !important;
}

/* MOBILE */
@media (max-width: 960px) {
  .line {
    display: none;
  }

  .stepper-wrapper {
    gap: 20px;
  }
}

@media (max-width: 768px) {
  .stepper-wrapper {
    gap: 0px;
  }
}
</style>